import { useApiMutation } from '../../../hooks/useApiMutation';
import { saveTemplate } from '../api/logbookApi';
import { UseApiMutationOptions } from '../types/loogBookTypes';

type MutationResponse = { message: string };
type MutationVariables = FormData;

/**
 * [Responsibility: API Mutation]
 * A dedicated hook for creating or updating a logbook template via the API.
 * It wraps the generic `useApiMutation` hook with specific types and API function.
 * @param options - Configuration options (e.g., onSuccess, successMessage) for the mutation.
 */
export const useCreateOrUpdateLogbookTemplate = (
  options?: UseApiMutationOptions<MutationResponse, Error, MutationVariables>
) => {
  return useApiMutation<MutationResponse, Error, MutationVariables>(saveTemplate, {
    errorMessage: 'Failed to save logbook template',
    invalidateQueryKeys: [['logbookTemplates']],
    ...options,
  });
};